/**
 * 蜜蜂Logo组件
 * BeeChat品牌标识
 */

import React from 'react'

interface BeeLogoProps {
  className?: string
  size?: number
  showText?: boolean
}

// 蜜蜂SVG Logo - 高对比度版本
export const BeeLogo: React.FC<BeeLogoProps> = ({ className = '', size = 32, showText = false }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    {/* 蜜蜂图标 */}
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className="bee-icon"
    >
      {/* 蜜蜂身体 - 更鲜明的黄色 */}
      <ellipse cx="16" cy="20" rx="9" ry="7" fill="#FFD43B" />
      {/* 黑色条纹 - 更粗更明显 */}
      <path d="M7 17.5h18v3H7z" fill="#1A1A1A" />
      <path d="M9 21h14v3H9z" fill="#1A1A1A" />
      {/* 头部 - 更大 */}
      <circle cx="16" cy="10" r="6" fill="#1A1A1A" />
      {/* 眼睛 - 更大更明显 */}
      <circle cx="13.5" cy="9" r="2" fill="white" />
      <circle cx="18.5" cy="9" r="2" fill="white" />
      <circle cx="13.5" cy="9" r="1" fill="#1A1A1A" />
      <circle cx="18.5" cy="9" r="1" fill="#1A1A1A" />
      {/* 翅膀 - 带蓝色渐变更明显 */}
      <ellipse cx="9" cy="13" rx="5" ry="4" fill="#E8F4FF" stroke="#B8D4E8" strokeWidth="1" />
      <ellipse cx="23" cy="13" rx="5" ry="4" fill="#E8F4FF" stroke="#B8D4E8" strokeWidth="1" />
      {/* 触角 */}
      <path d="M13 4c0-1.5 1-2.5 1-4" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 4c0-1.5-1-2.5-1-4" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" />
      {/* 触角顶端小圆 */}
      <circle cx="14" cy="2" r="1.5" fill="#1A1A1A" />
      <circle cx="18" cy="2" r="1.5" fill="#1A1A1A" />
      {/* 尾部刺 */}
      <path d="M16 27v4" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
    {/* 文字 */}
    {showText && (
      <span className="font-extrabold text-xl tracking-tight" style={{ color: '#FF2442' }}>
        BeeChat
      </span>
    )}
  </div>
)

// 简化版蜜蜂图标（用于移动端header）- 无背景版本
export const BeeIcon: React.FC<{ className?: string; size?: number }> = ({ className = '', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    {/* 蜜蜂身体 - 鲜艳黄色 */}
    <ellipse cx="12" cy="15" rx="7" ry="5.5" fill="#FFD43B" />
    {/* 黑色条纹 */}
    <path d="M5 13h14v2.5H5z" fill="#1A1A1A" />
    <path d="M7 16h10v2.5H7z" fill="#1A1A1A" />
    {/* 头部 */}
    <circle cx="12" cy="7.5" r="5" fill="#1A1A1A" />
    {/* 眼睛 */}
    <circle cx="10" cy="6.5" r="1.8" fill="white" />
    <circle cx="14" cy="6.5" r="1.8" fill="white" />
    <circle cx="10" cy="6.5" r="0.9" fill="#1A1A1A" />
    <circle cx="14" cy="6.5" r="0.9" fill="#1A1A1A" />
    {/* 翅膀 */}
    <ellipse cx="6" cy="10" rx="4" ry="3.5" fill="#E8F4FF" stroke="#B8D4E8" strokeWidth="0.8" />
    <ellipse cx="18" cy="10" rx="4" ry="3.5" fill="#E8F4FF" stroke="#B8D4E8" strokeWidth="0.8" />
    {/* 触角 */}
    <path d="M9.5 2c0-1-0.5-1.5-0.5-2.5" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M14.5 2c0-1 0.5-1.5 0.5-2.5" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="9.5" r="1.2" fill="#1A1A1A" />
    <circle cx="14.5" r="1.2" fill="#1A1A1A" />
  </svg>
)

export default BeeLogo